/**
 * Status pill component - Tactical Industrial style
 */
import React from "react";

const STATUS_MAP = {
  // Task
  "Planned":       { fg: "#94A3B8", bg: "rgba(148,163,184,0.1)", border: "rgba(148,163,184,0.3)" },
  "Pending":       { fg: "#F59E0B", bg: "rgba(245,158,11,0.1)",  border: "rgba(245,158,11,0.35)" },
  "Partial Done":  { fg: "#3B82F6", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.35)" },
  "Done":          { fg: "#10B981", bg: "rgba(16,185,129,0.1)",  border: "rgba(16,185,129,0.35)" },
  "Cancel":        { fg: "#EF4444", bg: "rgba(239,68,68,0.1)",   border: "rgba(239,68,68,0.35)" },
  "No Plan":       { fg: "#475569", bg: "rgba(71,85,105,0.15)",  border: "rgba(71,85,105,0.35)" },
  // Expense/Leave
  "submitted":         { fg: "#F59E0B", bg: "rgba(245,158,11,0.1)",  border: "rgba(245,158,11,0.35)" },
  "manager_approved":  { fg: "#3B82F6", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.35)" },
  "admin_approved":    { fg: "#8B5CF6", bg: "rgba(139,92,246,0.1)",  border: "rgba(139,92,246,0.35)" },
  "paid":              { fg: "#10B981", bg: "rgba(16,185,129,0.1)",  border: "rgba(16,185,129,0.35)" },
  "rejected":          { fg: "#EF4444", bg: "rgba(239,68,68,0.1)",   border: "rgba(239,68,68,0.35)" },
  // Live req
  "open":         { fg: "#F59E0B", bg: "rgba(245,158,11,0.1)",  border: "rgba(245,158,11,0.35)" },
  "in_progress":  { fg: "#3B82F6", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.35)" },
  "resolved":     { fg: "#10B981", bg: "rgba(16,185,129,0.1)",  border: "rgba(16,185,129,0.35)" },
  "closed":       { fg: "#475569", bg: "rgba(71,85,105,0.15)",  border: "rgba(71,85,105,0.35)" },
  // Billing
  "WIP":             { fg: "#F59E0B", bg: "rgba(245,158,11,0.1)",  border: "rgba(245,158,11,0.35)" },
  "Under Approval":  { fg: "#3B82F6", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.35)" },
  "Approved":        { fg: "#8B5CF6", bg: "rgba(139,92,246,0.1)",  border: "rgba(139,92,246,0.35)" },
  "Paid":            { fg: "#10B981", bg: "rgba(16,185,129,0.1)",  border: "rgba(16,185,129,0.35)" },
  "Invoice Sent":    { fg: "#EC4899", bg: "rgba(236,72,153,0.1)",  border: "rgba(236,72,153,0.35)" },
  "N/A":             { fg: "#475569", bg: "rgba(71,85,105,0.15)",  border: "rgba(71,85,105,0.35)" },
};

export default function StatusPill({ status, size = "sm" }) {
  const s = STATUS_MAP[status] || { fg: "#94A3B8", bg: "rgba(148,163,184,0.1)", border: "rgba(148,163,184,0.3)" };
  const label = String(status || "—").replace(/_/g, " ");
  const px = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]";
  return (
    <span
      data-testid={`status-${status}`}
      className={`mono uppercase tracking-wider inline-flex items-center gap-1.5 border rounded-sm ${px}`}
      style={{ color: s.fg, backgroundColor: s.bg, borderColor: s.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.fg }} />
      {label}
    </span>
  );
}
